import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { IRS_REPOSITORY, IrsRepository } from '@app/domain/repositories/ptrab/irs/irs.repository.contract';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { EnjoyedYear } from '@app/entities/models/ptrab/irs/enjoyed-year.model';
import {
  Dependant,
  IrsModel,
  IrsWithholdingModel,
  Spouse,
  WorkerPt,
  YoungBenefit
} from '@app/entities/models/ptrab/irs/irs.model';

import { IrsUseCases } from './irs.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class IrsUseCasesImpl implements IrsUseCases {
  #irsRepository: IrsRepository = inject(IRS_REPOSITORY);

  getData(): Observable<IrsModel> {
    return this.#irsRepository.getData();
  }

  modifyIndividualsData(workerPt: WorkerPt, authorization: TwoFactorAuthorization): Observable<IrsModel> {
    return this.#irsRepository.modifyIrsPersonalData(workerPt, authorization);
  }

  modifyIrsSpouse(spouse: Spouse, authorization: TwoFactorAuthorization): Observable<IrsModel> {
    return this.#irsRepository.modifyIrsSpouse(spouse, authorization);
  }

  modifyIrsDependent(dependant: Dependant, authorization: TwoFactorAuthorization): Observable<IrsModel> {
    return this.#irsRepository.modifyIrsDependent(dependant, authorization);
  }

  deleteIrsDependent(id: number): Observable<IrsModel> {
    return this.#irsRepository.deleteIrsDependent(id);
  }

  modifyIrsYoungBenefit(youngBenefit: YoungBenefit, authorization: TwoFactorAuthorization): Observable<IrsModel> {
    return this.#irsRepository.modifyIrsYoungBenefit(youngBenefit, authorization);
  }

  deleteIrsYoungBenefit(): Observable<IrsModel> {
    return this.#irsRepository.deleteIrsYoungBenefit();
  }

  getWithholding(): Observable<IrsWithholdingModel> {
    return this.#irsRepository.getWithholding();
  }

  modifyIrsWithholding(
    withholding: IrsWithholdingModel,
    authorization: TwoFactorAuthorization
  ): Observable<IrsWithholdingModel> {
    return this.#irsRepository.modifyIrsWithholding(withholding, authorization);
  }

  deleteIrsWithholding(): Observable<IrsWithholdingModel> {
    return this.#irsRepository.deleteIrsWithholding();
  }

  getEnjoyedYears(): Observable<EnjoyedYear[]> {
    return this.#irsRepository.getEnjoyedYears();
  }

  getError() {
    return this.#irsRepository.getError();
  }

  getErrorMsg() {
    return this.#irsRepository.getErrorMsg();
  }
}
